module.exports = __webpack_public_path__ + "r-v3/img/ai_chat.5803b38e.svg";